import { IsNotEmpty, IsString } from 'class-validator';
import { EmailActions } from './email-actions.type';

export class EmailCreationDto {
  @IsString()
  @IsNotEmpty()
  action!: EmailActions | string;

  @IsString()
  @IsNotEmpty()
  to!: string;

  @IsString()
  @IsNotEmpty()
  subject!: string;

  @IsString()
  @IsNotEmpty()
  text!: string;

  @IsString()
  @IsNotEmpty()
  html!: string;
}
